import {AbandonFlowModal, MainFooter, MainHeader, StyledGrid} from 'presentation/components';
import {FeaturesEnum, HomeEnum} from 'presentation/constants';
import {useMediaQueries, useQueryParams} from 'presentation/pages/private/hooks';
import {translations} from 'presentation/translations-new';
import React, {Fragment, useState} from 'react';
import {Navigate, useNavigate} from 'react-router-dom';
import {useFeatureFlag} from 'presentation/hooks/useFeatureFlag';
import {RequestScheduleLayout} from './components/RequestScheduleLayout';
import {RequestScheduleBeneficiaryData} from './components/RequestScheduleBeneficiaryData';

const {abandonModal, pageTitle} = translations['pt-br'].privateFlow.bookingFlow.requestSchedule;

export const RequestScheduleWrapper = () => {
	const [abandonFlowState, setAbandonFlowState] = useState(false);
	const {isMobile, isDesktop} = useMediaQueries();
	const navigate = useNavigate();
	const {SEARCH_PARAMS} = useQueryParams();
	const {isEnabled: pacmanFlagIsEnabled} = useFeatureFlag(FeaturesEnum.PORTAL_FEATURE_PACMAN);

	const {ufName, cityName, specialtyName, ufCode, specialtyCode, requestSchedulePermissionCity} =
		SEARCH_PARAMS;

	const handleClose = () => {
		setAbandonFlowState(true);
	};

	const handleConfirmExitFlow = () => {
		setAbandonFlowState(false);
		navigate(HomeEnum.HOME_PAGE);
	};

	const handleBack = () => {
		navigate(-1);
	};

	const shouldReturnHome =
		!ufName ||
		!cityName ||
		!requestSchedulePermissionCity ||
		!specialtyName ||
		!ufCode ||
		!specialtyCode ||
		pacmanFlagIsEnabled === false;

	if (shouldReturnHome) {
		return <Navigate to={HomeEnum.HOME_PAGE} />;
	}

	return (
		<Fragment>
			<MainHeader
				title={pageTitle}
				handleBack={handleBack}
				handleClose={handleClose}
				variant="subRoute"
			/>

			<StyledGrid.Root p={isMobile ? 2 : 4} height="100%">
				<StyledGrid.Item sm={12} md={12} lg={8}>
					<RequestScheduleLayout />
				</StyledGrid.Item>
				{isDesktop ? (
					<StyledGrid.Item sm={12} md={12} lg={4}>
						<RequestScheduleBeneficiaryData />
					</StyledGrid.Item>
				) : null}
			</StyledGrid.Root>

			<MainFooter />

			<AbandonFlowModal
				open={abandonFlowState}
				setOpen={setAbandonFlowState}
				headerTitle={abandonModal.headerTitle}
				title={abandonModal.title}
				description={abandonModal.description}
				handleConfirm={handleConfirmExitFlow}
			/>
		</Fragment>
	);
};
